import { Component, Input } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MyUtils } from "src/app/services/my-utils.service";
import { RecordsManager } from "../../records-manager";

@Component({
  selector: "app-custom-paginator",
  templateUrl: "./custom-paginator.component.html",
  styleUrls: ["./custom-paginator.component.scss"],
})
export class CustomPaginatorComponent<T extends object> {
  @Input()
  paginator!: MatPaginator;

  constructor(public recordsManager: RecordsManager<T>, public utils: MyUtils) {}

  get pages(): number[] {
    return Array.from({ length: this.paginator?.getNumberOfPages() }, (_, i) => i);
  }

  setPage(ix: number) {
    this.paginator.pageIndex = ix;
    this.paginator.page.emit();
  }

  get tableInfo() {
    if (!this.paginator) {
      return "";
    }
    let tot = this.paginator.length;
    let start = this.paginator.pageIndex * this.paginator.pageSize + 1;
    start = tot ? start : 0;
    let end = this.paginator.pageIndex * this.paginator.pageSize + this.paginator.pageSize;
    end = end > tot ? tot : end;
    return `${start} - ${end} ${this.utils.traslatei18n("of")} ${tot}`;
  }

  get nextIsDisabled() {
    if (!this.paginator) return false;
    let numOfPages = this.paginator.getNumberOfPages() - 1;
    return (
      this.paginator.pageIndex === numOfPages || numOfPages < 1 || this.recordsManager.isLoading
    );
  }
}
